import { createContext, useContext, useState } from "react";
import { ocrExtract } from "../api/ocr";

const OcrContext = createContext();

export function OcrProvider({ children }) {
    const [file, setFile] = useState(null);
    const [modeId, setModeId] = useState("mode_standard");
    const [preprocess, setPreprocess] = useState(true);
    const [contextJson, setContextJson] = useState(null);
    const [loading, setLoading] = useState(false);

    const runOcr = async () => {
        if (!file || loading) return;

        try {
            setLoading(true);

            const result = await ocrExtract({
                file,
                modeId,
                preprocess,
            });

            // ✅ ONLY STORE extracted context
            setContextJson(result.context);

        } catch (err) {
            console.error("OCR failed", err);
            alert("OCR failed");
        } finally {
            setLoading(false);
        }
    };

    return (
        <OcrContext.Provider
            value={{
                file,
                setFile,
                modeId,
                setModeId,
                preprocess,
                setPreprocess,
                contextJson,
                runOcr,
                loading,
            }}
        >
            {children}
        </OcrContext.Provider>
    );
}

export function useOcr() {
    return useContext(OcrContext);
}
